const questions = [
    //Συντηρητισμός vs Προοδευτισμός
    { question: "H κοινωνία πρέπει να προωθεί παραδοσιακές κοινωνικές αρχές.",
      effect: { a: 5, b: 0, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "H πορνογραφία έχει αρνητικές κοινωνικές συνέπειες και πρέπει να περιοριστεί.",
      effect: { a: 5, b: 0, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "Οι ποινές πρέπει να γίνουν αυστηρότερες για να μειωθεί η εγκληματικότητα.",
      effect: { a: 5, b: 0, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "Οι αρχές μου συνοψίζονται στο 'Πατρίς, Θρησκεία, Οικογένεια'.",
      effect: { a: 5, b: 0, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "H έκτρωση είναι φόνος και πρέπει να ποινικοποιηθεί στις περισσότερες ή όλες τις περιπτώσεις.",
      effect: { a: 5, b: 0, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "O σύγχρονος φεμινισμός έχει χρήσιμα αιτήματα.",
      effect: { a: -5, b: 0, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "Υποστηρίζω την κοινότητα ΛΟΑΤΚΙ.",
      effect: { a: -5, b: 0, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "H μαριχουάνα πρέπει να είναι νόμιμη για διάφορες χρήσεις.",
      effect: { a: -5, b: 0, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "To φύλο είναι κοινωνικό κατασκεύασμα.",
      effect: { a: -5, b: 0, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "H έκτρωση είναι ανθρώπινο δικαίωμα.",
      effect: { a: -5, b: 0, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    // Καπιταλισμός vs Σοσιαλισμός
    { question: "H παρέμβαση στην οικονομία προκαλεί στασιμότητα και τη συνολική μείωση της παραγωγής.",
      effect: { a: 0, b: 5, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "Όσο πιο ελεύθερες οι αγορές τόσο πιο ελεύθεροι οι άνθρωποι.",
      effect: { a: 0, b: 5, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "H κυβέρνηση είναι μεγαλύτερη αιτία ανισότητας από ότι o καπιταλισμός επειδή δημιουργεί μονοπώλια.",
      effect: { a: 0, b: 5, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "Η φορολογία πρέπει να μειωθεί σημαντικά.",
      effect: { a: 0, b: 5, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "Το οικονομικό μοντέλο στην Ελλάδα βασίζεται υπερβολικά στο κράτος και είναι εχθρικό προς την ατομική πρωτοβουλία.",
      effect: { a: 0, b: 5, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "H κυβέρνηση πρέπει να παρεμβαίνει στην οικονομία ώστε να προστατεύει τους πολίτες.",
      effect: { a: 0, b: -5, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "H ισότητα που φέρνει o κεντρικός σχεδιασμός είναι καλύτερη από τις ανισότητες του καπιταλιστικού συστήματος.",
      effect: { a: 0, b: -5, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "O κατώτατος μισθός πρέπει να αυξηθεί.",
      effect: { a: 0, b: -5, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "H υψηλότερη φορολογία στους πιο εύπορους θα ωφελήσει την κοινωνία.",
      effect: { a: 0, b: -5, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "H Ευρωπαϊκή Ένωση προωθεί τον καπιταλισμό και τις ανισότητες.",
      effect: { a: 0, b: -5, c: 0, d: 0, e: 0, f: 0, g: 0 }
    },

    // Εξουσία vs Αναρχία
    { question: "To κράτος πρέπει να είναι ενιαίο χωρίς πολλές εξουσίες στην αυτοδιοίκηση.",
      effect: { a: 0, b: 0, c: 5, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "Στην Ελλάδα τα πιο αυταρχικά καθεστώτα είχαν αποτελεσματικότερη διακυβέρνηση (Ιωάννης Μεταξάς, Χούντα των Συνταγματαρχών).",
      effect: { a: 0, b: 0, c: 5, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "Προτιμώ την ασφάλεια από την ελευθερία.",
      effect: { a: 0, b: 0, c: 5, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "Η δημοκρατία λόγω του υποτιθέμενου ηθικού πλεονεκτήματος αποκρύπτει τις κυβερνητικές αυθαιρεσίες.",
      effect: { a: 0, b: 0, c: 5, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "Τα αυταρχικά καθεστώτα παίρνουν αποφάσεις πιο γρήγορα.",
      effect: { a: 0, b: 0, c: 5, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "Ένα σύνταγμα περιορίζει τις κρατικές εξουσίες.",
      effect: { a: 0, b: 0, c: -5, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "Η κοινοβουλευτική δημοκρατία αποτελεί το καλύτερο καθεστώς.",
      effect: { a: 0, b: 0, c: -5, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "Υποστηρίζω το ομοσπονδιακό σύστημα.",
      effect: { a: 0, b: 0, c: -5, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "To κράτος αποτελεί απλά ένα μονοπώλιο στη βία και πρέπει να καταργηθεί.",
      effect: { a: 0, b: 0, c: -5, d: 0, e: 0, f: 0, g: 0 }
    },

    { question: "H άμεση δημοκρατία είναι αποτελεσματική.",
      effect: { a: 0, b: 0, c: -5, d: 0, e: 0, f: 0, g: 0 }
    },

    // Θρησκεία vs Κοσμικισμός
    { question: "H Ελλάδα αποτελεί έθνος με χριστιανικές αξίες.",
      effect: { a: 0, b: 0, c: 0, d: 5, e: 0, f: 0, g: 0 }
    },

    { question: "Tα θρησκευτικά πρέπει να είναι υποχρεωτικά στα σχολεία.",
      effect: { a: 0, b: 0, c: 0, d: 5, e: 0, f: 0, g: 0 }
    },

    { question: "H θρησκεία μου πρέπει να διατηρηθεί από τις επόμενες γενιές.",
      effect: { a: 0, b: 0, c: 0, d: 5, e: 0, f: 0, g: 0 }
    },

    { question: "Οι απόψεις μου σε κοινωνικά θέματα διαμορφώνονται σε σημαντικό βαθμό από τη θρησκεία.",
      effect: { a: 0, b: 0, c: 0, d: 5, e: 0, f: 0, g: 0 }
    },

    { question: "Ο ρόλος της Εκκλησίας στην Ελλάδα είναι γενικότερα θετικός.",
      effect: { a: 0, b: 0, c: 0, d: 5, e: 0, f: 0, g: 0 }
    },

    { question: "H Ελλάδα πρέπει να είναι κοσμικό κράτος χωρίς επίσημη θρησκεία.",
      effect: { a: 0, b: 0, c: 0, d: -5, e: 0, f: 0, g: 0 }
    },

    { question: "Η θρησκευτική πίστη είναι προσωπικό ζήτημα και δεν πρέπει να έχει ρόλο στη δημόσια πολιτική.",
      effect: { a: 0, b: 0, c: 0, d: -5, e: 0, f: 0, g: 0 }
    },

    { question: "Η θρησκεία δεν χρειάζεται να αναγράφεται σε ατομικά έγγραφα (αστυνομική ταυτότητα).",
      effect: { a: 0, b: 0, c: 0, d: -5, e: 0, f: 0, g: 0 }
    },

    { question: "Πιστεύω ότι η Ελλάδα είναι οπισθοδρομική χώρα σε διάφορα ζητήματα εξαιτίας της θρησκείας.",
      effect: { a: 0, b: 0, c: 0, d: -5, e: 0, f: 0, g: 0 }
    },

    { question: "Η επιστημονική και κοινωνική πρόοδος είναι σημαντικότερα από τη διάδοση της θρησκείας.",
      effect: { a: 0, b: 0, c: 0, d: -5, e: 0, f: 0, g: 0 }
    },

    // Περιβάλλον vs Βιομηχανία
    { question: "Πρέπει να δράσουμε άμεσα για την περιβαλλοντική προστασία και ιδίως την αντιμετώπιση δασικών πυρκαγιών.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 5, f: 0, g: 0 }
    },

    { question: "H επένδυση στην πράσινη ενέργεια αποτελεί σημαντικό βήμα για την κάλυψη των ενεργειακών αναγκών της χώρας μας.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 5, f: 0, g: 0 }
    },

    { question: "Υποστηρίζω τη χρήση πυρηνικής ενέργειας μαζί με άλλες ανανεώσιμες πηγές.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 5, f: 0, g: 0 }
    },

    { question: "Οι καταναλωτές πρέπει να αλλάξουν τις διατροφικές τους συνήθειες για την προστασία του περιβάλλοντος.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 5, f: 0, g: 0 }
    },

    { question: "H υπερθέρμανση του πλανήτη θα προκαλέσει χάος σε βάθος χρόνων.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 5, f: 0, g: 0 }
    },

    { question: "Οι επιπτώσεις της υπερθέρμανσης του πλανήτη παρουσιάζονται υπερβολικά.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: -5, f: 0, g: 0 }
    },

    { question: "H επένδυση στη πράσινη ενέργεια είναι σημαντική αλλά δε μπορούμε να περιμένουμε να αντικαταστήσουμε πλήρως τα ορυκτά καύσιμα.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: -5, f: 0, g: 0 }
    },

    { question: "Οι οικονομικές δραστηριότητες δε πρέπει να επηρεάζονται από περιβαλλοντικές ρυθμίσεις.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: -5, f: 0, g: 0 }
    },

    { question: "Η Ελλάδα πρέπει να ανακτήσει την εθνική βιομηχανία της ακόμα και χωρίς την πλήρη εφαρμογή περιβαλλοντικών ρυθμίσεων.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: -5, f: 0, g: 0 }
    },

    { question: "Σε ορισμένες περιοχές είναι δύσκολο οι πολίτες να μεταβούν σε πιο φιλικές προς το περιβάλλον δραστηριότητες (Πτολεμαΐδα).",
      effect: { a: 0, b: 0, c: 0, d: 0, e: -5, f: 0, g: 0 }
    },

    // Εθνικισμός vs Διεθνισμός
    { question: "Υποστηρίζω την ουδετερότητα στην εξωτερική πολιτική.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 5, g: 0 }
    },

    { question: "H υπερεξάρτηση που δημιουργεί η παγκοσμιοποίηση διαβάλλει εθνικές αξίες.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 5, g: 0 }
    },

    { question: "H Τουρκία θα διατηρεί πάντα εχθρική στάση απέναντι μας ανεξαρτήτως κυβέρνησης.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 5, g: 0 }
    },

    { question: "Ένα εθνικό νόμισμα είναι απαραίτητο για τη διαμόρφωση ανεξάρτητης πολιτικής.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 5, g: 0 }
    },

    { question: "H αποχώρηση από την Ευρωπαϊκή Ένωση είναι αναγκαία λόγω της αντιμετώπισης μας τις τελευταίες δεκαετίες.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 5, g: 0 }
    },

    { question: "Χωρίς τη στήριξη της Ευρωπαϊκής Ένωσης, η Ελλάδα θα βρισκόταν σε χειρότερη κατάσταση.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: -5, g: 0 }
    },

    { question: "Οι πολιτικές λιτότητας κατά τη δεκαετία 2010 ήταν δικαιολογημένες.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: -5, g: 0 }
    },

    { question: "H Ελλάδα πρέπει να βελτιώσει τις σχέσεις της με άλλες χώρες, συμπεριλαμβανομένης και της Τουρκίας.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: -5, g: 0 }
    },

    { question: "Θα υποστήριζα μια ομοσπονδιακή Ευρώπη.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: -5, g: 0 }
    },

    { question: "Η άνοδος εθνοκεντρικών κυβερνήσεων (ΗΠΑ, Ιταλία, Ουγγαρία) παρεμποδίζει την παγκόσμια συνεργασία.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: -5, g: 0 }
    },

    // Αφομοίωση vs Πολυπολιτισμικότητα
    { question: "Υποστηρίζω μια κοινή πολιτιστική και εθνική ταυτότητα.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0, g: 5 }
    },

    { question: "H κυβέρνηση δεν προστατεύει τα σύνορα αρκετά.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0, g: 5 }
    },

    { question: "Οι μετανάστες δυσκολεύονται να ενσωματωθούν στην ελληνική κοινωνία.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0, g: 5 }
    },

    { question: "Η πολιτική ανοιχτών συνόρων τoυ 2015 δεν πρέπει να επαναληφθεί.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0, g: 5 }
    },

    { question: "Εάν οι μετανάστες θέλουν να ζήσουν εδώ πρέπει να ενσωματωθούν στην ελληνική κουλτούρα.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0, g: 5 }
    },

    { question: "H μετανάστευση πρέπει να γίνει ευκολότερη.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0, g: -5 }
    },

    { question: "Κανένας άνθρωπος δεν είναι παράνομος.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0, g: -5 }
    },

    { question: "H Ελλάδα καταστρατηγεί τα δικαιώματα των μεταναστών.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0, g: -5 }
    },

    { question: "H Ελλάδα πρέπει να προωθήσει τη συμπερίληψη των μειονοτήτων.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0, g: -5 }
    },

    { question: "Οι μετανάστες συνεισφέρουν στην επίλυση του δημογραφικού προβλήματος.",
      effect: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0, g: -5 }
    }
];

export default questions;